import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import Modal from "./Modal";
import SignUpPage from "../pages/SignUpPage";

const Navbar = ({ onLoginClick, onJoinClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showJoinOverlay, setShowJoinOverlay] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
  ];

  const handleLogin = () => {
    if (onLoginClick) {
      onLoginClick();
      return;
    }

    navigate("/");
  };

  const handleJoin = () => {
    if (onJoinClick) {
      onJoinClick();
      return;
    }

    setShowJoinOverlay(true);
  };

  return (
    <nav className="glass-nav fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">
        <Link
          to="/"
          className="flex items-center gap-3 text-lg sm:text-xl font-bold text-collaborb-band4 hover:text-collaborb-spherical-mid transition-colors"
        >
          <img src="/collaborb-logo.png" alt="CollabOrb logo" className="w-10 h-10 sm:w-12 sm:h-12 object-contain" />
          <div className="logo">
            <img src="/collaborb-text.png" alt="CollabOrb wordmark" className="w-24 h-8 sm:w-36 sm:h-10 md:w-48 md:h-12 object-contain" />
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-2 rounded-full border border-slate-200/80 bg-white/70 px-2 py-1 shadow-sm">
          {links.map((link) => {
            const isActive = location.pathname === link.to;

            return (
              <Link
                key={link.to}
                to={link.to}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-collaborb-inner text-white shadow-sm"
                    : "text-slate-600 hover:bg-slate-100 hover:text-collaborb-band4"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button onClick={handleLogin} className="secondary-button !px-5 !py-2.5 !text-sm">
            Log In
          </button>
          <button onClick={handleJoin} className="primary-button !px-5 !py-2.5 !text-sm">
            Join Now
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="p-1 rounded-md hover:bg-gray-100 transition-colors"
          >
            {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden mx-4 mb-4 rounded-3xl border border-slate-200 bg-white/95 p-4 shadow-2xl">
          <div className="space-y-2">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block rounded-2xl px-4 py-3 text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? "bg-collaborb-inner text-white"
                    : "text-slate-700 hover:bg-slate-100 hover:text-collaborb-band4"
                }`}
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
          <hr className="my-4" />
          <div className="space-y-2">
            <button
              onClick={() => {
                handleLogin();
                setIsOpen(false);
              }}
              className="secondary-button !w-full !justify-center !text-sm"
            >
              Log In
            </button>
            <button
              onClick={() => {
                handleJoin();
                setIsOpen(false);
              }}
              className="primary-button !mt-2 !w-full !justify-center !text-sm"
            >
              Join Now
            </button>
          </div>
        </div>
      )}

      <Modal
        isOpen={showJoinOverlay}
        onClose={() => setShowJoinOverlay(false)}
        overlayClassName="backdrop-blur-md bg-slate-950/45"
        panelClassName="max-w-xl"
        contentClassName="p-3 pt-12 sm:p-4 sm:pt-12"
      >
        <SignUpPage isOverlay onClose={() => setShowJoinOverlay(false)} />
      </Modal>
    </nav>
  );
};

export default Navbar;
